<template>
<div>
  <v-row no-gutters justify="end" class="pt-1" style="height: 32px">
    <dd-transparent-button
      v-if="isUseGuide"
      :minWidth="140"
      color="green"
      @click="onClickUseGuideClick"
    >
      <v-icon color="green">mdi-help-box</v-icon>
      <span class="v-btn-icon-tutorial">操作ガイドを表示</span>
    </dd-transparent-button>
  </v-row>
  <v-card class="ma-1 px-5 base-area">
    <v-card-text>
      <v-row no-gutters class="px-1 pt-3 pb-0">
        <div style="display: inline-block;">
          <span class="view-title" id="v-step-0">{{ viewTitle }}</span>
          <!-- 位置調整用 -->
        </div>
        <div style="display: inline-block;padding-top:2px" class="mr-2">
          <dd-icon-button-with-tooltip
            v-if="isUseGuide"
            addClass="d-none d-sm-block"
            color="green"
            message="操作ガイドを表示します"
            icon="mdi-help-box"
            @click="onClickUseGuideClick"
          />
        </div>
        <div style="padding-top:2px">
          <dd-custom-button
            v-if="isShowCreateButton"
            :disabled="isDisableCreateButton"
            :rounded="true"
            :minWidth="60"
            :small="true"
            @click="onCreateButtonClick"
          >
            {{ functionName }}を新規追加する
          </dd-custom-button>
        </div>
      </v-row>

      <hr class="section-line">

      <!-- **************************************************************************************************** --
        -- 検索条件
        -- **************************************************************************************************** -->
      <div class="pa-2">
        <v-row no-gutters>
          <v-col :cols="12">
            <v-row no-gutters justify="start" id="starndardWidth">
              <dd-sub-header>
                <span v-if="isConditionHide && ![undefined, null].includes(conditionDetails)">指定している検索条件</span>
                <span v-else>以下の検索条件で絞り込む</span>
                <span style="float: right;">
                  <dd-transparent-button
                    v-if="isConditionHide"
                    :rounded="true"
                    :minWidth="80"
                    @click="onSearchButtonClick">
                    <div class="condition-expansion"><v-icon class="px-1 condition-aria-icon" color="#1F2B38">mdi-magnify</v-icon><span class="condition-aria-text">検索</span></div>
                  </dd-transparent-button>
                  <dd-transparent-button
                    :rounded="true"
                    :minWidth="80"
                    @click="onClearButtonClick">
                    <div class="condition-expansion"><v-icon class="px-1 condition-aria-icon" color="#1F2B38">mdi-filter-remove</v-icon><span class="condition-aria-text">クリア</span></div>
                  </dd-transparent-button>
                  <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
                    <div v-if="!isConditionHide" class="condition-expansion"><span style="vertical-align: middle;">検索条件を閉じる</span><v-icon>mdi-chevron-up</v-icon></div>
                    <div v-else class="condition-expansion"><span style="vertical-align: middle;">検索条件を開く</span><v-icon>mdi-chevron-down</v-icon></div>
                  </dd-transparent-button>
                </span>
              </dd-sub-header>
            </v-row>
            <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
              <v-row no-gutters v-if="isShowHeaderDescription">
                <v-col :cols="12" v-if="headerDescription === null">
                  <span class="ml-1 view-description">登録済み{{functionName}}を検索したい条件を入力して[検索をする]を押下してください。
                  <span v-if="isShowCreateButton">新規に{{functionName}}を追加する場合は[{{ functionName }}を新規追加する]ボタンを押下してください。</span></span>
                </v-col>
                <v-col :cols="12" v-else>
                  <span>{{ headerDescription }}</span>
                </v-col>
              </v-row>
              <slot>
              <!-- 任意設定エリア -->
              </slot>
              <v-row class="mt-2" no-gutters justify="center" v-if="isDefaultSearchDisable">
                <dd-custom-button
                  :rounded="true"
                  :minWidth="200"
                  :large="true"
                  :tooltipText="`入力された検索条件で登録済み${functionName}を検索します`"
                  :enableToolTip="helpUseFlg"
                  :tooltipBottom="true"
                  @click="onSearchButtonClick">
                  検索をする
                </dd-custom-button>
              </v-row>
            </div>
            <div class="px-1 py-2 condition-area" v-show="isConditionHide && ![undefined, null].includes(conditionDetails)">
              <v-row no-gutters v-if="isConditionChange">
                <v-icon class="mx-1" color="green" small>mdi-information-outline</v-icon>
                <span style="font-size:0.8rem;color:green;">条件が変更されました。「検索をする」で再読み込みしてください。</span>
              </v-row>
              <v-row no-gutters>
                <span style="display: inline-block">
                  <span v-for="item in conditionDetails" :key="item.key">
                    <v-chip class="mx-1" color="#4169e1" small dark :close="item.delete" v-if="item.type !== 'checkbox' && ![undefined, null, ''].includes(conditions[item.key]) || (item.type === 'checkbox' && conditions[item.key] === true)" @dblclick="isConditionHide = false" @click:close="onRemoveConditionClick(item.key, item.type)">
                      <!--
                      <span>{{item.name}}：</span><span style="color:greenyellow">{{ conditions[item.value] }}</span>
                      -->
                      <span>{{ getItemName(item) }}</span><span style="color:greenyellow;white-space: pre-wrap;">{{ getItemValue(item) }}</span>
                    </v-chip>
                  </span>
                </span>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- **************************************************************************************************** --
        -- 検索結果
        -- **************************************************************************************************** -->
      <div class="px-1 pt-1 pb-4" v-if="items.length > 0">
        <v-row no-gutters>
          <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="5" class="px-1">
            <v-row no-gutters>
              <span class="search-number">{{ items.length }}</span><span class="mt-2 text-black">件 の検索結果</span>
              <div class="mt-2" v-if="![undefined, null, ''].includes(vSearchText)">
                <span span class="filter-row-text">（</span>
                <span class="filter-number">{{ filteredRowCount }}</span>
                <span span class="filter-row-text">件 表示中）</span>
              </div>
              <div class="px-2 pt-1">
                <a
                  class="condition-clear-bottom"
                  @click="onClearButtonClick">
                  条件をクリア
                </a>
              </div>
            </v-row>
          </v-col>
          <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7">
            <span v-if="isShowCsvDownload">
              <dd-custom-button
                :loading="isCsvDownloader"
                :disabled="isOutputButtonDisabled"
                tooltipText="一覧をCSVファイル形式でダウンロードします"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
                @click="onCsvButtonClick">
                CSVで出力
                <template v-slot:loader>
                  <span>出力中...</span>
                </template>
              </dd-custom-button>
            </span>
            <span v-if="isShowXlsDownload">
              <dd-custom-button
                :loading="isXlsDownloader"
                :disabled="isOutputButtonDisabled"
                tooltipText="一覧をXLSファイル形式でダウンロードします"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
                @click="onXlsButtonClick">
                EXCELで出力
                <template v-slot:loader>
                  <span>出力中...</span>
                </template>
              </dd-custom-button>
            </span>
            <a id="csvdownload" href="#" style="display:none;">ダウンロード</a>
            <a id="xlsdownload" href="#" style="display:none;">ダウンロード</a>
          </v-col>
          <v-spacer />
          <div style="padding-top: 2px" class="px-2">
            <div style="display: flex; align-items: end;">
              <span class="mt-2 text-black">簡易絞り込み：</span>
              <v-text-field v-model="quickFilter" type="text" @input="onQuickFilterChanged" style="max-width: 200px;" outlined dense hide-details />
              <span class="ml-2" />
              <span class="mt-2 text-black">表示件数：</span>
              <v-select v-model="vItemsPerPage" :items="itemsPerPageList" @change="onPageSizeChanged" style="max-width: 95px;" suffix="件" outlined dense hide-details />
            </div>
          </div>
        </v-row>

        <hr class="section-line mb-2">

        <v-row no-gutters class="mt-2">
          <v-col :cols="12" class="px-1">
            <div class="mt-2 px-1 grid-container" :class="gridTheme" >
              <AgGridVue
                :style="{ width: '100%', height: '100%' }"
                :columnDefs="itemHeaders"
                :rowData="items"
                :defaultColDef="defaultColDef"
                :gridOptions="customGridOptions !== null ? customGridOptions : gridOptions"
                :localeText="localeText"
                :readOnlyEdit="true"
                :pagenation="true"
                :paginationPageSize="vItemsPerPage"
                @cellDoubleClicked="onCellDblClick"
                @grid-ready="onGridReady"
              />
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-else class="pb-2" />
    </v-card-text>
  </v-card>
</div>
</template>

<script>
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'

const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'DdSearchList',
  mixins: [flowMixin],
  props: {
    // 画面タイトル
    viewTitle: String,
    /**
     * 機能名
     */
    functionName: String,
    /**
     * 検索条件タイトル
     */
    conditionAreaTitle: {
      type: String,
      default: null
    },
    /**
     * 通常検索ボタン表示制御
     */
    isDefaultSearchDisable: {
      type: Boolean,
      default: false
    },
    /**
     * 追加ボタン表示
     */
    isShowCreateButton: {
      type: Boolean,
      default: true
    },
    /**
     * 追加ボタン使用不可
     */
    isDisableCreateButton: {
      type: Boolean,
      default: false
    },
    /**
     * データテーブル用ヘッダ
     */
    itemHeaders: Array,
    /**
     * データテーブル用データ
     */
    items: Array,
    /**
     * データテーブルキー
     */
    itemKey: String,
    /**
     * 検索条件
     */
    conditions: Object,
    /**
     * 検索条件簡易表示用
     */
    conditionDetails: Array,
    /**
     * ページ
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 1ページ当たりの行数
     */
    itemsPerPage: {
      type: Number,
      default: 50
    },
    itemsPerPageList: {
      type: Array,
      default: () => [15, 25, 50, 100]
    },
    /**
     * 検索結果件数
     */
    rowNumber: Number,
    /**
     * チェックボックス表示時有無
     */
    isShowSelect: {
      type: Boolean,
      default: true
    },
    /**
     * 一括操作ボタン表示有無
     */
    isBatchCommand: {
      type: Boolean,
      default: true
    },
    /**
     * CSV出力ボタン表有無（DEFAULT:TRUE)
     */
    isShowCsvDownload: {
      type: Boolean,
      default: true
    },
    /**
     * CSV出力用props
     */
    csvFunction: String,
    csvConditions: Object,
    csvFileName: String,
    /**
     * Xls出力用props
     */
    xlsFunction: String,
    xlsConditions: Object,
    xlsFileName: String,
    /**
     * XLS出力ボタン表示有無（DEFAULT:FALSE)
     */
    isShowXlsDownload: {
      type: Boolean,
      default: false
    },
    /**
     * 選択状態
     */
    selected: Array,
    /**
     * 検索後条件非表示
     */
    isConditionHideAfterSearch: {
      type: Boolean,
      default: false
    },
    /**
     * 説明文
     */
    isShowHeaderDescription: {
      type: Boolean,
      default: true
    },
    headerDescription: {
      type: String,
      default: null
    },
    isUseGuide: {
      type: Boolean,
      default: false
    },
    initSearchText: {
      type: String,
      default: ''
    },
    /**
     * Grid設定
     */
    customGridOptions: {
      type: Object,
      default: null
    },
    /**
     * テーマ
     * ag-theme-alpine(-dark) / ag-theme-balham(-dark) / ag-theme-material のいずれか
     */
    gridTheme: {
      type: String,
      default: 'ag-theme-balham'
    }
  },
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdIconButtonWithTooltip,
    DdSubHeader
  },
  data: () => ({
    screenWidth: null,
    tableWidth: null,
    scrollAddress: 0,
    // 条件制御用
    isConditionHide: false,
    // 条件変更
    isConditionChange: false,
    // 一覧制御用
    isCsvDownloader: false,
    isXlsDownloader: false,
    // ページネーション用
    vItemsPerPage: 0,
    vPage: 1,
    vSearchText: '',
    // AdGrid
    selectedTheme: 'ag-theme-balham',
    themes: [
      { text: 'Alpine', value: 'ag-theme-alpine' },
      { text: 'Balham', value: 'ag-theme-balham' },
      { text: 'Material', value: 'ag-theme-material' }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      editable: true
    },
    gridOptions: {
      domLayout: 'normal',
      pagination: true
    },
    localeText: {
      contains: '含む',
      notContains: '含まない',
      equals: '等しい',
      notEqual: '等しくない',
      startsWith: 'で始まる',
      endsWith: 'で終わる',
      blank: '空白',
      notBlank: '空白ではない',
      filterOoo: 'フィルター条件',
      applyFilter: '適用',
      resetFilter: 'リセット'
    },
    quickFilter: null
  }),
  computed: {
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      currentKaishaCode: 'users/currentKaishaCode',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredRowCount () {
      const items = this.itemHeaders.map(h => h.value)
      const text = this.vSearchText
      const length = this.items.filter(r => {
        for (let i = 0; i < items.length; i++) {
          const hit = this.filtering(r[items[i]], text, r)
          if (hit) { return true }
        }
        return false
      }).length
      return length
    },
    isOutputButtonDisabled () {
      return this.items.length === 0
    }
  },
  created () {
  },
  mounted () {
    // スクロールイベント付与
    window.addEventListener('scroll', this.scrollEvent)
    this.vItemsPerPage = this.itemsPerPage
  },
  methods: {
    onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
    },
    onPageSizeChanged () {
      if (this.gridApi) {
        this.gridApi.paginationSetPageSize(this.vItemsPerPage)
      }
    },
    onQuickFilterChanged (parms) {
      const value = parms
      this.gridApi.setQuickFilter(value)
    },

    // フィルターリセット
    clearAllFilters () {
      this.gridApi.setFilterModel(null)
    },
    // ボタン操作
    onClickUseGuideClick: function () {
      this.$emit('guideOn')
    },
    onCreateButtonClick: function () {
      this.$emit('create')
    },
    onSearchButtonClick: function () {
      this.scrollAddress = 0
      this.$emit('search')
      if (this.isConditionHideAfterSearch) {
        this.isConditionChange = false
        this.isConditionHide = true
      }
    },
    onClearButtonClick: function () {
      this.$emit('clear')
    },
    onRemoveConditionClick: function (itemNm) {
      this.isConditionChange = true
      this.$emit('removeCondition', itemNm)
    },
    onCsvButtonClick: function () {
      this.isCsvDownloader = true
      // 画面のない要素そのまま出力
      setTimeout(() => {
        const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
        const csv = this.gridApi.getDataAsCsv()
        const bom = '\uFEFF'
        const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.getElementById('csvdownload')
        link.href = URL.createObjectURL(blob)
        link.download = this.csvFileName + '_' + ts + '.csv'
        link.click()
        this.isCsvDownloader = false
      }, 0)
    },
    onXlsButtonClick: function () {
      this.isXlsDownloader = true
      // APIを実行して出力
      this.HttpClient
        .requestFileByPost(this.xlsFunction, this.xlsConditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = this.xlsFileName + '_' + ts + '.xlsx'
          elem.click()
        })
    },
    // データテーブル操作
    onCellDblClick: function (e) {
      console.log('onCellDblClick', e)
      // data部のみ（１レコードデータ）を親に渡す
      this.$emit('dblclick', e.data)
    },

    getItemName: function (item) {
      if (item.type === 'checkbox') {
        console.log(item.name, this.conditions[item.key])
        return this.conditions[item.key] === true ? item.name : ''
      } else {
        return item.name + (item.showValue ? '：' : '')
      }
    },
    getItemValue: function (item) {
      console.log('getItemValue', this.conditions, item)
      if (!item.showValue) return ''

      if (item.convertValue === true) {
        return this.getItemValueFromMasterData(item)
      } else {
        if ([undefined, null].includes(item.value)) return ''

        const dotIndex = item.value.indexOf('.')
        if (dotIndex > 0) {
          const itemArray = item.value.split('.')
          console.log(this.conditions[itemArray[0]][itemArray[1]])
          return this.conditions[itemArray[0]][itemArray[1]]
        } else {
          return this.conditions[item.value]
        }
      }
    },
    getItemValueFromMasterData: function (item) {
      var rtnVal = ''
      const self = this
      if (item.master === 'mstshubetsu') {
        const m = self.shubetsuList.filter((elem) => {
          return elem.kaishaCd === self.currentKaishaCode && elem.sbtShuruiCd === item.kbnShuruiCd && elem.sbtCd === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].sbtNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msyskubun') {
        const m = self.kubunList.filter((elem) => {
          return elem.kaishaCd === self.currentKaishaCode && elem.kbnShuruiCd === item.kbnShuruiCd && elem.code === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].codeNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msteigyosho') {
        const m = self.eigyoshoList.filter((elem) => {
          return elem.id === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].eigyoshoNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msttorihikisaki') {
        const m = self.torihikisakiList.filter((elem) => {
          return elem.id === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].torihikisakiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstsharyo') {
        const m = self.sharyoList.filter((elem) => {
          return elem.id === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].jidoshaHyojiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstjinin') {
        const m = self.jininList.filter((elem) => {
          return elem.id === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].jininNmSei
        } else {
          rtnVal = ''
        }
      }
      return rtnVal
    },
    // 検索条件エリア表示（外部参照用）
    showConditionArea: function () {
      this.isConditionHide = false
    },
    // 検索条件エリア非表示（外部参照用）
    hideConditionArea: function () {
      this.isConditionHide = true
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
</script>
<style scoped>
.condition-aria-icon {
  margin-top: -4px;
  font-size: 1.25rem;
}
.condition-aria-text {
  font: normal normal bold 12px / 20px YuGothic;
  letter-spacing: 0px;
  color: #1F2B38;
}
.filter-row-text {
  margin-left: 4px;
  margin-right: 4px;
  color: green;
}
/* App.css更新 */
tbody {
    overflow-x:hidden !important;
    display:block !important;
    width:100%;
}

/**
 * --------------------------------------------------
 * AdGrid個別設定
 * --------------------------------------------------
 * 必要に応じて呼び出し元画面に::v-deepで設定してください
 */
.grid-container {
  height: calc(100vh - 380px);
}

/**
 * --------------------------------------------------
 * AdGrid一般設定
 * --------------------------------------------------
 */
::v-deep .ag-tooltip {
  background-color: #FFF2CC !important;
  color: #1F2B38 !important;
  padding: 8px;
}
::v-deep .ag-paging-panel {
  /* --ag-header-background-colorはag標準変数を参照 ※実値は"#f5f7f7" */
  background-color: var(--ag-header-background-color);
}
</style>
